import SkillsPage from "./SkillsPage.page";

export default SkillsPage;
